import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { toQueryParams } from "../utils/http.util";
import { PublicConfigService } from "./public.config.service";

@Injectable({
    providedIn: 'root'
})
export class WidgetsService {

  constructor(private httpClient: HttpClient, private publicConfigService: PublicConfigService) {

  }

  getFormWidgetData(stageId: string) {
    return this.httpClient.get(`${this.publicConfigService.rpBaseUrl}/api/widget/form`, {
      params: toQueryParams({ stageId })
    });
  }

  getPeerReviewWidgetData(stageId: string) {
    return this.httpClient.get(`${this.publicConfigService.rpBaseUrl}/api/widget/judging/judge`, {
      params: toQueryParams({ stageId })
    });
  }

  getAdminReviewWidgetData(stageId: string) {
    return this.httpClient.get(`${this.publicConfigService.rpBaseUrl}/api/widget/admin-review`, {
      params: toQueryParams({ stageId })
    });
  }

  getAdminReviewWidgetMoreInfo(stageId: string) {
    return this.httpClient.get(`${this.publicConfigService.rpBaseUrl}/api/widget/admin-review-more-info`, {
      params: toQueryParams({ stageId })
    });
  }

  getEvaluationParticipantWidgetData(stageId: string) {
    return this.httpClient.get(`${this.publicConfigService.rpBaseUrl}/api/widget/judging/participant`, {
      params: toQueryParams({ stageId })
    });
  }

  getEvaluationJudgeWidgetData(stageId: string) {
    return this.httpClient.get(`${this.publicConfigService.rpBaseUrl}/api/widget/judging/judge`, {
      params: toQueryParams({ stageId })
    });
  }

  getTimelineStagesData(stageIds: string[]) {
    return this.httpClient.get(`${this.publicConfigService.rpBaseUrl}/api/widget/timeline`, {
      params: {
        stageIds: stageIds
      }
    });
  }

  getAccountsWidgetData() {
    return this.httpClient.get(`${this.publicConfigService.rpBaseUrl}/api/widget/accounts`);
  }

  getFormStatsWidgetData(key: string, ValuesSeparator?: string) {
    return this.httpClient.get(`${this.publicConfigService.rpBaseUrl}/api/widget/formstats`, {
      params: toQueryParams({key, ValuesSeparator})
    });
  }

  getStageCountersWidgetData(stageIds: [string]) {
    return this.httpClient.post(`${this.publicConfigService.rpBaseUrl}/api/widget/stagecounters?loader=false`, {stageIds: stageIds});
  }
}
